<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save } from "./butcher-material.store";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import type { IMaterialStock } from "../../entities/material-stock";
  import SupplierDropdown from "../../components/Business/SupplierDropdown.svelte";
  import RoomTypeDropdown from "../../components/Business/RoomTypeDropdown.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit =
    $record != null &&
    $record.quantity >= 0 &&
    $record.lotNumber != "" &&
    !!$record.clfMaterialTypeId &&
    !!$record.supplierId &&
    !!$record.roomTypeId &&
    !!$record.validFromDate;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IMaterialStock> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/butcher-materials/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/butcher-materials`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <ClfDropdown name="Materiale" placeholder="materiale" schema="MATERIALSX" required={true} bind:value={$record.clfMaterialTypeId} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <Input name="Lotto" placeholder="lotto" required={true} bind:value={$record.lotNumber} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <NumberInput name="Quantità" placeholder="quantità" required={true} bind:value={$record.quantity} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <FormField>
                <SupplierDropdown name="Fornitore" required={true} bind:value={$record.supplierId} />
              </FormField>
            </div>
            <div class="column is-6">
              <FormField>
                <RoomTypeDropdown name="Stoccaggio" required={true} plantId={0} phaseCode="M" bind:value={$record.roomTypeId} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <FormField>
                <Input name="N° DDT" placeholder="" required={false} bind:value={$record.ddtNumber} />
              </FormField>
            </div>
            <div class="column is-6">
              <FormField>
                <DateInputString name="Data DDT" placeholder="" required={false} bind:value={$record.ddtDate} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <FormField>
                <DateInputString name="Inizio Validità" placeholder="" required={true} bind:value={$record.validFromDate} />
              </FormField>
            </div>
            <div class="column is-6">
              <FormField>
                <DateInputString name="Fine Validità" placeholder="" required={false} bind:value={$record.validUptoDate} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Note" placeholder="note" required={false} bind:value={$record.notes} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</MainLayout>
